<template>
  <div class="animated fadeIn">
    <b-card-group class="mb-4">
      <b-card @click="goTotalUsers">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-people"></i>
        </div>
        <div class="h4 mb-0">{{current.totalUsers}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Total Users</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="info" :value="100"/>
      </b-card>
      <b-card @click="goUnverifiedUsers">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-user-follow"></i>
        </div>
        <div class="h4 mb-0">{{current.emailUnverified}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Non Verified Users</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="success" :value="current.emailUnverified*100/current.totalUsers"/>
      </b-card>
      <b-card @click="goNoDeviceUsers">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-user-unfollow"></i>
        </div>
        <div class="h4 mb-0">{{current.noDeviceUsers}}</div>
        <small class="text-muted text-uppercase font-weight-bold">No Device Users</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="warning" :value="current.noDeviceUsers*100/current.totalUsers"/>
      </b-card>
      <b-card @click="goDisabledUsers">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-user-unfollow"></i>
        </div>
        <div class="h4 mb-0">{{current.disabledUsers}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Inactive Users</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="warning" :value="current.disabledUsers*100/current.totalUsers"/>
      </b-card>      
    </b-card-group>
    <b-card-group class="mb-4">
      <b-card @click="goTotalDevices">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-screen-smartphone"></i>
        </div>
        <div class="h4 mb-0">{{current.totalDevices}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Total Devices</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" :value="100"/>
      </b-card>
      <b-card @click="goUnregisteredDevices">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-ghost"></i>
        </div>
        <div class="h4 mb-0">{{current.unregisteredDevices}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Unregistered Devices</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="warning" :value="current.unregisteredDevices*100/current.totalDevices"/>
      </b-card>
      <b-card @click="goStolenDevices">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-magnet"></i>
        </div>
        <div class="h4 mb-0">{{current.stolenDevices}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Stolen Devices</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" variant="danger" :value="current.stolenDevices*100/current.totalDevices"/>
      </b-card>      
      <b-card @click="goTotalGroups">
        <div class="h1 text-muted text-right mb-4">
          <i class="icon-badge"></i>
        </div>
        <div class="h4 mb-0">{{current.totalGroups}}</div>
        <small class="text-muted text-uppercase font-weight-bold">Total Groups</small>
        <b-progress height={} class="progress-xs mt-3 mb-0" :value="100"/>
      </b-card>
    </b-card-group>
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 class="card-title mb-0">Trends</h4>
          <div class="small text-muted">
            <b-form-radio-group 
              v-model="selectedPeriod" class="mr-3" buttons button-variant="outline-info" name="radiosBtn"
              :options="periodOptions"
            ></b-form-radio-group>
          </div>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group 
              v-model="selectedChart" class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" name="radiosBtn"
              :options="chartOptions"
            ></b-form-radio-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      <DailyUserChart 
        v-if="dailyChartData" v-show="selectedChart === 'sign'"
        :chartData="dailyChartData" :height="300" 
        :key="componentKey"
        class="chart-wrapper" style="height:300px;margin-top:40px;" 
      >
      </DailyUserChart>
      <DailyTotalChart 
        v-if="dailyChartData" v-show="selectedChart === 'total'"
        :chartData="dailyChartData" :height="300" 
        :key="componentKey+1"
        class="chart-wrapper" style="height:300px;margin-top:40px;" 
      >
      </DailyTotalChart>      
    </b-card>
  </div>
</template>

<script>
import { Event } from 'vue-tables-2'
import { extendMoment } from 'moment-range'

import DailyUserChart from './dashboard/DailyUserChart'
import DailyTotalChart from './dashboard/DailyTotalChart'
import { Callout } from '@coreui/vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    DailyUserChart,
    DailyTotalChart
  },
  data: function () {
    return {
      current: {
        totalUsers: 0,
        disabledUsers: 0,
        emailUnverified: 0,
        noDeviceUsers: 0,
        totalDevices: 0,
        stolenDevices: 0,
        unregisteredDevices: 0,
        totalGroups: 0,
        noUserGroups: 0,
        totalLogs:0,
      },
      daily: [],
      selectedChart: 'sign',
      selectedPeriod: 30,
      chartOptions: [
        {text: 'Sign In/Up', value: 'sign'},
        {text: 'Total Counts', value: 'total'}
      ],
      periodOptions: [
        {text: 'Last Month', value: 30},
        {text: 'Last 3 Month', value: 90},
        {text: 'Last 6 Month', value: 180},
        {text: 'Last Year', value: 365}
      ],
      dailyChartData: null,
      componentKey: 0
    }
  },
  watch: {
    async selectedPeriod() {
      await this.getDailyChartData()
      this.componentKey += 1
    }
  },
  created() {
    this.$bind('current', this.$firebase.firestore().collection('statistics').doc('current'))
    this.$bind('daily', this.$firebase.firestore().collection('daily'))
  },
  mounted() {
    this.getDailyChartData()
  },
  methods: {
    goTotalUsers() {
      this.$router.push({path: '/users', query: {disabled: null, emailVerified: null, hasDevice: null, createdFrom: null, createdTo: null}})
    },
    goUnverifiedUsers() {
      this.$router.push({path: '/users', query: {disabled: null, emailVerified: false, hasDevice: null, createdFrom: null, createdTo: null}})
    },
    goNoDeviceUsers() {
      this.$router.push({path: '/users', query: {disabled: null, emailVerified: null, hasDevice: false, createdFrom: null, createdTo: null}})
    },
    goDisabledUsers() {
      this.$router.push({path: '/users', query: {disabled: true, emailVerified: null, hasDevice: null, createdFrom: null, createdTo: null}})
    },
    goTotalDevices() {
      this.$router.push({path: '/devices', query: {stolen: null, registered: null, createdFrom: null, createdTo: null}})
    },
    goStolenDevices() {
      this.$router.push({path: '/devices', query: {stolen: true, registered: null, createdFrom: null, createdTo: null}})
    },
    goUnregisteredDevices() {
      this.$router.push({path: '/devices', query: {stolen: null, registered: false, createdFrom: null, createdTo: null}})
    },
    goTotalGroups() {
      this.$router.push({path: '/groups', query: {name: null, hasUser: null, createdFrom: null, createdTo: null}})
    },
    goNoUserGroups() {
      this.$router.push({path: '/groups', query: {name: null, hasUser: false, createdFrom: null, createdTo: null}})
    },    
    async getDailyChartData() {
      const moment = extendMoment(this.$moment)
      const range = moment.range(moment().subtract(this.selectedPeriod, 'days'), moment().subtract(1, 'days'))
      const dailyIds = Array.from(range.by('day')).map(m => m.format('YYYY-MM-DD'))
      const dailyRefs = dailyIds.map(m => this.$firebase.firestore().collection('daily').doc(m))
      const promiseArray = dailyRefs.map(m => m.get())
      const snapshots = await Promise.all(promiseArray)

      this.dailyChartData = snapshots.map(m => {
        const label = this.$moment(m.id, 'YYYY-MM-DD').format('M/D') 
        if (m.exists) {
          return {
            label: label, 
            signUps: m.data().signUps ? m.data().signUps: 0, signIns: m.data().signIns ? m.data().signIns: 0, 
            totalUsers: m.data().totalUsers? m.data().totalUsers: 0, totalDevices: m.data().totalDevices ? m.data().totalDevices: 0
          }
        } else {
          return {
            label: label, 
            signUps: 0, signIns: 0,
            totalUsers:0, totalDevices: 0
          }
        }
      })
    },    
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
